module.exports = "/_assets/images/sparkle.svg";